import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { PageSection } from "../components/organisms/PageSection.jsx";
import { BodyText } from "../components/atoms/Text.jsx";
import { Button } from "../components/atoms/Button.jsx"

export function Login() {
    const navigate = useNavigate();
    const { login, isLoggedIn, initializing } = useAuth();

    // redirectで戻ってきた後、ログイン済みならホームへ
    useEffect(() => {
        if (!initializing && isLoggedIn) {
            navigate("/", { replace: true });
        }
    }, [initializing, isLoggedIn, navigate]);

    const handleLogin = async () => {
        await login();
    }

    const testHandleLogin = async () => {
        await login();
        navigate("/", { replace: true });
    };

    return (
        <>
            <PageSection>ログイン</PageSection>
            <BodyText>
                初めにログインが必要です。<br/>
                「r(社員番号)@rinnai.co.jp」と、普段PCにログインする時のパスワードをご入力ください。<br/>
                ログイン後はそのままの画面でお待ちください。
            </BodyText>
            <Button variant="primary" onClick={ handleLogin }>
                ログイン
            </Button>
        </>
    );
}